import {
  IonButtons,
  IonContent,
  IonHeader,
  IonInput,
  IonItem,
  IonItemDivider,
  IonItemGroup,
  IonLabel,
  IonMenuButton,
  IonPage,
  IonSelect,
  IonSelectOption,
  IonTitle,
  IonToolbar
} from '@ionic/react'
import React from 'react'
import { connect } from 'react-redux'
import withAuth from '../../components/with.auth'
import { State } from '../../store'
import {
  ProfileCountry,
  ProfileSettings,
  updateSettings,
  updateSettingsType
} from '../../store/auth'
import { addNotification, addNotificationType } from '../../store/notification'

interface DispatchProps {
  updateSettings: updateSettingsType
  addNotification: addNotificationType
}

interface StateProps {
  settings: ProfileSettings
  countries: ProfileCountry[]
}

type Props = StateProps & DispatchProps

const Profile: React.FC<Props> = props => {
  const [mail, setMail] = React.useState(props.settings.mail)
  const [tel, setTel] = React.useState(props.settings.tel)

  const [anrede, setAnrede] = React.useState(props.settings.anrede)
  const [title, setTitle] = React.useState(props.settings.title)
  const [firstname, setFirstname] = React.useState(props.settings.firstname)
  const [middlename, setMiddlename] = React.useState(props.settings.middlename)
  const [lastname, setLastname] = React.useState(props.settings.lastname)

  const [profession, setProfession] = React.useState(props.settings.profession)

  const [street, setStreet] = React.useState(props.settings.street)
  const [city, setCity] = React.useState(props.settings.city)
  const [postCode, setPostCode] = React.useState(props.settings.post_code)
  const [country, setCountry] = React.useState(props.settings.country)

  React.useEffect(() => {
    props.updateSettings({
      mail,
      tel,
      profession,
      anrede,
      title,
      firstname,
      middlename,
      lastname,
      street,
      city,
      post_code: postCode,
      country
    }).then((updated: boolean) => {
      if (updated) {
        props.addNotification({
          message: 'Änderung gespeichert',
          color: 'success',
          duration: 1000
        })
      }
    })
  })

  return (
    <IonPage color={'primary'}>
      <IonHeader>
        <IonToolbar color={'primary'}>
          <IonButtons slot="start">
            <IonMenuButton autoHide={false} />
          </IonButtons>
          <IonTitle>Profil</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent
        className="ion-padding no-footer"
        color={'background'}
      >
        <IonItemGroup>
          <IonItemDivider>
            <IonLabel>Allgemeine Daten</IonLabel>
          </IonItemDivider>
          <IonItem>
            <IonLabel position={'floating'}>Benutzername</IonLabel>
            <IonInput readonly value={props.settings.username} />
          </IonItem>
          <IonItem>
            <IonLabel position={'floating'}>E-Mail</IonLabel>
            <IonInput value={mail} onIonChange={e => setMail(e.detail.value!)} />
          </IonItem>
          <IonItem>
            <IonLabel position={'floating'}>Telefon</IonLabel>
            <IonInput value={tel} onIonChange={e => setTel(e.detail.value!)} />
          </IonItem>
          <IonItem>
            <IonLabel position={'floating'}>Beruf</IonLabel>
            <IonInput value={profession} onIonChange={e => setProfession(e.detail.value!)} />
          </IonItem>
        </IonItemGroup>

        <IonItemGroup style={{marginTop: 16}}>
          <IonItemDivider>
            <IonLabel>Person</IonLabel>
          </IonItemDivider>
          <IonItem>
            <IonLabel position={'floating'}>Anrede</IonLabel>
            <IonSelect value={anrede} onIonChange={e => setAnrede(e.detail.value!)}>
              <IonSelectOption value={'0'}>Frau</IonSelectOption>
              <IonSelectOption value={'1'}>Herr</IonSelectOption>
            </IonSelect>
          </IonItem>
          <IonItem>
            <IonLabel position={'floating'}>Titel</IonLabel>
            <IonInput value={title} onIonChange={e => setTitle(e.detail.value!)} />
          </IonItem>
          <IonItem>
            <IonLabel position={'floating'}>Vorname</IonLabel>
            <IonInput value={firstname} onIonChange={e => setFirstname(e.detail.value!)} />
          </IonItem>
          <IonItem>
            <IonLabel position={'floating'}>Nachname</IonLabel>
            <IonInput value={lastname} onIonChange={e => setLastname(e.detail.value!)} />
          </IonItem>
        </IonItemGroup>

        <IonItemGroup style={{marginTop: 16}}>
          <IonItemDivider>
            <IonLabel>Adresse</IonLabel>
          </IonItemDivider>
          <IonItem>
            <IonLabel position={'floating'}>Straße</IonLabel>
            <IonInput value={street} onIonChange={e => setStreet(e.detail.value!)} />
          </IonItem>
          <IonItem>
            <IonLabel position={'floating'}>Postleitzahl</IonLabel>
            <IonInput value={postCode} onIonChange={e => setPostCode(e.detail.value!)} />
          </IonItem>
          <IonItem>
            <IonLabel position={'floating'}>Stadt</IonLabel>
            <IonInput value={city} onIonChange={e => setCity(e.detail.value!)} />
          </IonItem>
          <IonItem>
            <IonLabel position={'floating'}>Land</IonLabel>
            <IonSelect value={country} onIonChange={e => setCountry(e.detail.value!)}>
              {props.countries.map(c => (
                <IonSelectOption key={c.Value} value={c.Value}>{c.DisplayText}</IonSelectOption>
              ))}
            </IonSelect>
          </IonItem>
        </IonItemGroup>
      </IonContent>
    </IonPage>
  )
}

export default withAuth(connect<StateProps, DispatchProps, {}, State>(
  ({auth}) => ({
    settings: auth.settings!,
    countries: auth.countries,
  }),
  {
    updateSettings,
    addNotification,
  }
)(Profile))
